import { CAMERA_ID_KEY, MICROPHONE_ID_KEY, SPEAKER_ID_KEY } from "@/utils/constant";

export type LayoutType = "" | "full" | "main";
export enum AppView {
  Authorized = 1,
  UnAuthorized = 2,
  NotFound = 3,
  Blank = 4,
}

export enum UserRole {
  UnConfirm = 0,
  Teacher = 1,
  Student = 2,
}

export enum FeatureSettings {
  DynamicVideoAdjuster = "dynamic_video_adjuster",
}

export interface AppState {
  layout: LayoutType;
  appView: AppView;
  toast: ToastData;
  cameraDeviceId: string;
  microphoneDeviceId: string;
  speakerDeviceId: string;
  userRole: UserRole;
  isLowBandWidth: boolean;
  isLowBandWidthDueToDownlink: boolean;
  replacedClassId: string;
  havePermissionCamera: boolean;
  havePermissionMicrophone: boolean;
  havePermissionSpeaker: boolean;
  enabledFeatures: string[];
}
export interface ToastData {
  message: string;
  isPlayingSound?: boolean;
  bigIcon?: any;
  isMedal?: boolean;
}
const cameraDeviceId = localStorage.getItem(CAMERA_ID_KEY);
const microphoneDeviceId = localStorage.getItem(MICROPHONE_ID_KEY);
const speakerDeviceId = localStorage.getItem(SPEAKER_ID_KEY);
const state: AppState = {
  layout: "main",
  appView: AppView.Blank,
  toast: { message: "", isPlayingSound: false },
  cameraDeviceId: cameraDeviceId || "",
  microphoneDeviceId: microphoneDeviceId || "",
  speakerDeviceId: speakerDeviceId || "",
  userRole: UserRole.UnConfirm,
  isLowBandWidth: false,
  isLowBandWidthDueToDownlink: false,
  replacedClassId: "",
  havePermissionCamera: true,
  havePermissionMicrophone: true,
  havePermissionSpeaker: true,
  enabledFeatures: [],
};

export default state;
